import React from 'react';
import { ArrowRightIcon, CheckIcon, LockIcon, QuoteIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { CHECKOUT_URL, IMAGES, PRICES, modules, testimonials } from '../data/funnel';
import { formatUsd } from '../utils/currency';
const painPoints = ['Ronca, jadea y se agota en caminatas de 10 minutos.', 'Se rasca los pliegues hasta dejarse la piel roja.', 'Duda antes de subir al sofá o arrastra las patas al levantarse.', 'Cada visita al veterinario termina en otra factura de tres cifras.'];
export function SalesPage() {
  return <main className="w-full bg-cream pb-24" data-id="element-226" data-mp="1jzk5ria7uhsn">
      <div className="bg-navy-deep text-paper" data-id="element-227" data-mp="1oxvfzu4faube">
        <div className="mx-auto flex max-w-6xl flex-wrap items-center justify-center gap-x-2 px-5 py-2.5 text-center text-xs font-medium text-gold-pale sm:text-sm" data-id="element-228" data-mp="1ouzho4ony3mf">
          <ZapIcon className="h-3.5 w-3.5 text-gold" data-id="element-229" data-mp="3qprosvz7hq2h" />
          Oferta de lanzamiento: <strong className="font-bold text-paper" data-id="element-230" data-mp="3vobbwzpjd7wf">85% de descuento</strong>{' '}
          para dueños en USA · solo esta semana
        </div>
      </div>

      <section className="mx-auto max-w-6xl px-5 pt-12 sm:pt-16" data-id="element-231" data-mp="3aljigdr9h1hz">
        <div className="grid items-center gap-10 lg:grid-cols-[1.15fr_1fr] lg:gap-14" data-id="element-232" data-mp="35rf9joyfqje9">
          <div data-id="element-233" data-mp="30uosozet3jrs">
            <h1 className="font-display text-[2rem] font-bold leading-[1.12] tracking-tight text-navy-deep sm:text-[2.9rem]" data-id="element-234" data-mp="30u6o9fhzpz8s">
              El plan de 30 días que protege la columna, la respiración y la piel de tu Bulldog
              Francés
            </h1>
            <p className="mt-5 max-w-xl text-lg leading-relaxed text-navy/75" data-id="element-235" data-mp="3oj80zexuvwjv">
              El Protocolo de Biohacking traduce lo que hacen los dueños de Frenchies de 12 y 14
              años en una rutina diaria de 7 minutos, con el{' '}
              <strong className="font-semibold text-navy-deep" data-id="element-236" data-mp="3fijpaqvxq8a5">Protocolo Spine-Shield</strong> como
              núcleo.
            </p>

            <ul className="mt-7 grid gap-2.5 sm:grid-cols-2" data-id="element-237" data-mp="243w9vu0hndmb">
              {['Rutina diaria de 7 minutos', 'Transición de dieta semana por semana', 'Protocolo de calor para verano', 'Acceso inmediato en PDF + móvil'].map(item => <li key={item} className="flex items-start gap-2.5 text-sm text-navy-deep/85" data-id="element-238" data-mp="1vnf7ofvh16hu">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold" data-id="element-239" data-mp="20kxiycwynxt0" />
                  {item}
                </li>)}
            </ul>

            <div className="mt-8 flex flex-wrap items-center gap-x-5 gap-y-3" data-id="element-240" data-mp="1ms8yd6wzs6ak">
              <a href={CHECKOUT_URL} className="group inline-flex items-center justify-center gap-2 rounded-lg bg-navy-deep px-7 py-4 text-base font-bold text-paper shadow-card transition-colors duration-150 ease-out hover:bg-navy sm:text-lg" data-id="element-241" data-mp="1rmli7i2drjmu">
                Quiero el protocolo por ${formatUsd(PRICES.blueprint)}
                <ArrowRightIcon className="h-5 w-5 transition-transform duration-200 ease-out group-hover:translate-x-1" data-id="element-242" data-mp="17xb4g9m738rd" />
              </a>
              <p className="text-sm text-navy/60" data-id="element-243" data-mp="p90z36dtthka">
                <span className="line-through" data-id="element-244" data-mp="ka7i33zbz8fd">${formatUsd(PRICES.blueprintValue)}</span> hoy{' '}
                <strong className="font-bold text-navy-deep" data-id="element-245" data-mp="y9ytqy2dkcq7">
                  ${formatUsd(PRICES.blueprint)}
                </strong>
              </p>
            </div>
          </div>

          <div className="justify-self-center" data-id="element-246" data-mp="187d90uckavgx">
            <img src={IMAGES.cover} alt="El Protocolo de Biohacking para Bulldogs Franceses, plan de 30 días, en ebook y tablet" className="w-full max-w-md rounded-xl shadow-lift" data-id="element-247" data-mp="18624utf7flpa" />
          </div>
        </div>
      </section>

      <section className="mx-auto mt-20 max-w-6xl px-5" data-id="element-248" data-mp="1czefu0qyntzk">
        <div className="grid gap-10 lg:grid-cols-[1fr_1.1fr] lg:items-start lg:gap-16" data-id="element-249" data-mp="1qy4dbhhozvog">
          <div data-id="element-250" data-mp="1qvryveb583g5">
            <h2 className="font-display text-2xl font-bold leading-snug text-navy-deep sm:text-3xl" data-id="element-251" data-mp="1lz1gulfs2xs3">
              Si reconoces dos o más de estas señales, el reloj ya está corriendo
            </h2>
            <ul className="mt-6 space-y-3" data-id="element-252" data-mp="2a2hmwqwf51u6">
              {painPoints.map(p => <li key={p} className="flex items-start gap-3 border-l-2 border-alert/60 pl-4 text-base leading-relaxed text-navy/80" data-id="element-253" data-mp="2a0da1jgjkshr">
                  {p}
                </li>)}
            </ul>
          </div>
          <figure className="overflow-hidden rounded-xl" data-id="element-254" data-mp="1n4386kwniee1">
            <img src={IMAGES.food} alt="Ingredientes frescos de comida natural para perro sobre una mesada de piedra clara" className="aspect-[3/2] w-full object-cover" data-id="element-255" data-mp="1r33qm2b7vf0i" />
            <figcaption className="mt-2 text-sm leading-relaxed text-navy/60" data-id="element-256" data-mp="213mhhh177vrx">
              El protocolo no exige cocinar todos los días. Empieza retirando tres ingredientes de
              la croqueta que tu perro ya come.
            </figcaption>
          </figure>
        </div>
      </section>

      <section className="mx-auto mt-20 max-w-6xl px-5" data-id="element-257" data-mp="10tbmp4yep5aw">
        <h2 className="font-display text-2xl font-bold text-navy-deep sm:text-3xl" data-id="element-258" data-mp="vu8ghh6owt1c">
          Qué hay dentro del protocolo
        </h2>
        <p className="mt-2 max-w-2xl text-base text-navy/65" data-id="element-259" data-mp="r2qpnlyds8u3">
          Cinco bloques que se ejecutan en orden. Cada uno toma menos de una tarde en configurar.
        </p>

        <ol className="mt-8 space-y-px overflow-hidden rounded-xl bg-navy-deep/10" data-id="element-260" data-mp="i3n84mev41hp">
          {modules.map(m => <li key={m.number} className="grid gap-2 bg-paper p-6 sm:grid-cols-[auto_1fr] sm:gap-6 sm:p-7" data-id="element-261" data-mp="d3hb0qptpms8">
              <span className="font-display text-lg font-bold text-gold sm:pt-0.5" data-id="element-262" data-mp="3649mscdu9x2">{m.number}</span>
              <div data-id="element-263" data-mp="22j8byt89kv30">
                <h3 className="font-display text-lg font-bold text-navy-deep" data-id="element-264" data-mp="22jqged52yfm0">{m.title}</h3>
                <p className="mt-1.5 max-w-2xl text-[0.95rem] leading-relaxed text-navy/70" data-id="element-265" data-mp="1xkdnbanm8caz">
                  {m.description}
                </p>
              </div>
            </li>)}
        </ol>
      </section>

      <section className="mx-auto mt-20 max-w-6xl px-5" data-id="element-266" data-mp="mq21xp6wl7u">
        <h2 className="font-display text-2xl font-bold text-navy-deep sm:text-3xl" data-id="element-267" data-mp="3i269u5ijdm48">
          Dueños que ya dejaron de reaccionar
        </h2>
        <div className="mt-8 grid gap-6 lg:grid-cols-[1.25fr_1fr]" data-id="element-268" data-mp="3n2aqpwncwiuz">
          <figure className="flex flex-col overflow-hidden rounded-xl bg-navy-deep text-paper" data-id="element-269" data-mp="elpg6bf2thpr">
            <img src={testimonials[0].photo} alt={`${testimonials[0].name} abrazando a su Bulldog Francés en casa`} className="aspect-[4/3] w-full object-cover" data-id="element-270" data-mp="jkagsby8q3eq" />
            <blockquote className="flex flex-1 flex-col p-6 sm:p-7" data-id="element-271" data-mp="9ll8naw5bxbo">
              <QuoteIcon className="h-5 w-5 text-gold" data-id="element-272" data-mp="2qb05fcvs9295" />
              <p className="mt-3 font-display text-lg leading-relaxed sm:text-xl" data-id="element-273" data-mp="2qa73cp7rr0xc">
                {testimonials[0].quote}
              </p>
              <figcaption className="mt-auto pt-5 text-sm text-gold-pale" data-id="element-274" data-mp="2mt2nzvtmi0vg">
                <span className="font-semibold text-paper" data-id="element-275" data-mp="2mr850n1wwiu0">{testimonials[0].name}</span> ·{' '}
                {testimonials[0].location} · {testimonials[0].dogAge}
              </figcaption>
            </blockquote>
          </figure>

          <div className="grid gap-6" data-id="element-276" data-mp="2rsfagfgl15xi">
            {testimonials.slice(1).map(t => <figure key={t.name} className="flex h-full flex-col rounded-xl border border-navy-deep/10 bg-paper p-6" data-id="element-277" data-mp="242kzy4jqjtgf">
                <p className="text-[0.95rem] leading-relaxed text-navy/80" data-id="element-278" data-mp="1z5bd8wnqdvwa">“{t.quote}”</p>
                <figcaption className="mt-auto pt-4 text-sm text-navy/55" data-id="element-279" data-mp="2dtxp2oe5g5ir">
                  <span className="font-semibold text-navy-deep" data-id="element-280" data-mp="290mtjjesfb65">{t.name}</span> · {t.location} ·{' '}
                  {t.dogAge}
                </figcaption>
              </figure>)}
          </div>
        </div>
      </section>

      <section className="mx-auto mt-20 max-w-3xl px-5" data-id="element-281" data-mp="1gawd33ponx6v">
        <div className="rounded-2xl border border-navy-deep/10 bg-paper p-7 shadow-card sm:p-10" data-id="element-282" data-mp="uupfj9d8kdr8">
          <h2 className="font-display text-2xl font-bold text-navy-deep sm:text-3xl" data-id="element-283" data-mp="zttnjwofc5fz">
            Tu acceso hoy
          </h2>
          <dl className="mt-6 divide-y divide-navy-deep/10 border-y border-navy-deep/10" data-id="element-284" data-mp="14qae0xj3ivw8">
            <div className="flex items-baseline justify-between gap-4 py-3" data-id="element-285" data-mp="18v07kfqa7ydz">
              <dt className="text-[0.95rem] text-navy/80" data-id="element-286" data-mp="1dtbdwghdbqrg">
                Protocolo de Biohacking — Plan de 30 días
              </dt>
              <dd className="shrink-0 text-sm text-navy/55" data-id="element-287" data-mp="1ips73p3fcvbe">
                ${formatUsd(PRICES.blueprintValue)}
              </dd>
            </div>
            <div className="flex items-baseline justify-between gap-4 py-3" data-id="element-288" data-mp="1shxueliqeok9">
              <dt className="text-[0.95rem] text-navy/80" data-id="element-289" data-mp="1wj1cleo94won">
                Checklist de longevidad imprimible + calendario de 30 días
              </dt>
              <dd className="shrink-0 text-sm text-navy/55" data-id="element-290" data-mp="21ivyt4x30y3d">Incluido</dd>
            </div>
            <div className="flex items-baseline justify-between gap-4 py-3" data-id="element-291" data-mp="3m0y698y6xovg">
              <dt className="text-[0.95rem] text-navy/80" data-id="element-292" data-mp="3h0k60d2tzj7z">
                Actualizaciones de por vida del protocolo
              </dt>
              <dd className="shrink-0 text-sm text-navy/55" data-id="element-293" data-mp="3d00a1ctzulnf">Incluido</dd>
            </div>
          </dl>

          <div className="mt-6 flex flex-wrap items-end justify-between gap-4" data-id="element-294" data-mp="38289xvj73t85">
            <div data-id="element-295" data-mp="8jywmv6aeo4c">
              <p className="text-sm font-semibold uppercase tracking-[0.14em] text-navy/50" data-id="element-296" data-mp="8kgyq8fmrwk6">
                Hoy pagas
              </p>
              <p className="font-display text-5xl font-bold leading-none text-navy-deep" data-id="element-297" data-mp="3vy2udebljuew">
                ${formatUsd(PRICES.blueprint)}
              </p>
            </div>
            <p className="text-sm text-navy/60" data-id="element-298" data-mp="3qx5dd52bp6ez">Pago único · sin suscripción</p>
          </div>

          <a href={CHECKOUT_URL} className="group mt-7 flex w-full items-center justify-center gap-2 rounded-lg bg-gold px-6 py-4 text-lg font-bold text-navy-deep transition-colors duration-150 ease-out hover:bg-gold-light" data-id="element-299" data-mp="sbc9re9im4h7">
            Empezar el protocolo hoy
            <ArrowRightIcon className="h-5 w-5 transition-transform duration-200 ease-out group-hover:translate-x-1" data-id="element-300" data-mp="2wh9isyv8vtnf" />
          </a>

          <div className="mt-5 flex flex-wrap items-center gap-x-6 gap-y-2 text-xs text-navy/55" data-id="element-301" data-mp="36dkupnqxahhc">
            <span className="flex items-center gap-1.5" data-id="element-302" data-mp="3kcuesyi91vql">
              <ShieldCheckIcon className="h-4 w-4 text-navy/40" data-id="element-303" data-mp="3kb9jh6o428ro" />
              Garantía de 30 días sin preguntas
            </span>
            <span className="flex items-center gap-1.5" data-id="element-304" data-mp="3u2xcvd489zvs">
              <LockIcon className="h-4 w-4 text-navy/40" data-id="element-305" data-mp="3u2dyu7hp7vn1" />
              Pago cifrado
            </span>
          </div>
        </div>
      </section>

      <footer className="mx-auto mt-16 max-w-3xl px-5 text-xs leading-relaxed text-navy/45" data-id="element-306" data-mp="6xy0nka9pgbl">
        Material educativo. No sustituye la consulta veterinaria. © {new Date().getFullYear()} The
        Frenchie Longevity Report.
      </footer>
    </main>;
}